const CID = {
  // CID 的 key 需要与 route.name 相同，在pageChange时，能自动打PV。
  Home: 'c_power_tiftouev',
  ExportBillAfterTimeNode: 'c_power_m67vx4ms',
  BillList: 'c_power_rdbjsjpi',
  BilledDetail: 'c_power_jky3ooa5',
  InvoiceNotice: 'c_power_fobs32bw',
  MonthBillDetail: 'c_power_q4zcg8rp',

  NotSign: 'c_power_noauth_page',
  Profit: 'c_power_gains',
  Device: 'c_power_device',
  Cooperation: 'c_power_cooperation_info',
  NoAuth: 'c_power_noauth',
  Introduction: 'c_power_adpage',
  SupplementalAgreement: 'c_power_katx',
  SubjectChangeAgreement: 'c_power_ztbg',
  CooperationRenewAgreement: 'c_power_zytx',
  Abnormal: '',
  HomeEarn: 'c_power_wp1gdpip',
  FoodEarn: 'c_power_58ejvaph',
  ContactSalesman: 'c_power_hp',
  AnalyticsDetail: 'c_power_e0nb9mp5',
  ReferenceInfo: 'c_power_o34g1x6u',
  TradeEffectData: 'c_power_shengyitongshuju_ddwi705r',
  ServiceLevelPoiList: 'c_power_ga5l1gmr',
  ServiceLevelPoiListSearch: 'c_power_w8nptfhx',
  ServiceLevelPoiDetail: 'c_power_4fa8fg0o',
};

const BID = {
  HOME_MY_BILL: 'b_power_ertaykd7_mc',
  HOME_PROFIT_TIP: 'b_power_ex9lwfjg_mc',
  HOME_CONFIRM_MASK_MV: 'b_power_na918a1j_mv',
  HOME_CONFIRM_MASK_MC: 'b_power_na918a1j_mc',
  HOME_CONFIRM_MODAL_OK: 'b_power_m0dcho30_mc',
  HOME_CONFIRM_MODAL_CANCEL: 'b_power_lzspe2cp_mc',
  HOME_WALLET_MV: 'b_power_7fn3ki64_mv',
  HOME_WALLET_MC: 'b_power_7fn3ki64_mc',
  HOME_ACTIVITY: 'b_power_xw4iu8ic_mc',
  HOME_INVOICE: 'b_power_8w2wa7gj_mc',
  HOME_POI_INFO: 'b_power_ggviuwva_mc',
  HOME_DEVICE: 'b_power_rreylq42_mc',
  HOME_CONTRACT: 'b_power_ldihxfxf_mc',
  HOME_WALLET_DEPOSIT: 'b_power_3u34d886_mc',
  HOME_BILL_PROFIT: 'b_power_lx6f26rz_mc',
  HOME_BILL_PROFIT_QUESTION: 'b_power_o6x52xdn_mc',
  HOME_BILL_DEPOSIT_RECORD_MV: 'b_power_ka6gs9dc_mv',
  HOME_BILL_DEPOSIT_RECORD_MC: 'b_power_ka6gs9dc_mc',
  HOME_BILL_DEPOSIT_BTN_MV: 'b_power_oworiup1_mv',
  HOME_BILL_DEPOSIT_BTN_MC: 'b_power_oworiup1_mc',
  HOME_BILL_DEPOSIT_QUSTION: 'b_power_sujdeg1m_mc',
  HOME_BILL_CREATE_WALLET_MV: 'b_power_57ij1dj2_mv',
  HOME_BILL_CREATE_WALLET_MC: 'b_power_57ij1dj2_mc',
  HOME_DEPOSIT_CANCEL: 'b_power_h913g482_mc',
  HOME_DEPOSIT_OK: 'b_power_mrzf8yec_mc',
  HOME_ANALYTICS_MV: 'b_power_da2ozt9y_mv',
  HOME_ANALYTICS_MC: 'b_power_da2ozt9y_mc',
  HOME_REFERENCE_INFO: 'b_power_1p0ign13_mc',
  HOME_REFERENCE_INFO_MV: 'b_power_1p0ign13_mv',
  HOME_AD_BANNER_MV: 'b_power_8tr9i4t7_mv',
  HOME_AD_BANNER_MC: 'b_power_8tr9i4t7_mc',
  HOME_AD_MODAL_MV: 'b_power_yp03dcbu_mv',
  HOME_AD_MODAL_MC: 'b_power_yp03dcbu_mc',
  HOME_SERVIVE_LEVEL_MV: 'b_power_yjji4xoz_mv',
  HOME_SERVIVE_LEVEL_MC: 'b_power_yjji4xoz_mc',
  HOME_SERVIVE_LEVEL_EXPLAIN_MC: 'b_power_ibvm6nu8_mc',

  ASK_FOR_HELP_CONTRACT_SERVICE: 'b_power_fds9bq03_mc',
  ASK_FOR_HELP_CONTRACT_BD: 'b_power_doxnzndv_mc',
  EXPORT_AFTER_SUBMIT: 'b_power_030rd6hd_mc',
  INVOICE_WRITEOFF_AMOUNT: 'b_power_xmorelhk_mc',
  INVOICE_COPY_CONTRACT_MV: 'b_power_9ru8n3fv_mv',
  INVOICE_COPY_CONTRACT_MC: 'b_power_9ru8n3fv_mc',
  INVOICE_COPY_ADDRESS: 'b_power_e0opvbox_mc',
  INVOICE_COPY_EMAIL: 'b_power_29a0cs5a_mc',
  BILL_DETAIL_CONFIRM_MODAL_MV: 'b_power_3ufp6vkh_mv',
  BILL_DETAIL_CONFIRM_MODAL_MC: 'b_power_3ufp6vkh_mc',
  BILL_DETAIL_CONFIRM_BTN_MV: 'b_power_8ndgxb5g_mv',
  BILL_DETAIL_CONFIRM_BTN_MC: 'b_power_8ndgxb5g_mc',
  BILL_DETAIL_SALE_BILL: 'b_power_hc6tn04e_mc',
  BILL_DETAIL_RENT_BILL: 'b_power_32xq6a6g_mc',
  BILL_DETAIL_OTHER_MV: 'b_power_8n8u47sd_mv',
  BILL_DETAIL_OTHER_MC: 'b_power_8n8u47sd_mc',
  BILL_DETAIL_RECEIVALBE: 'b_power_3mvmta6m_mc',
  BILL_LIST_BILLED_MC: 'b_power_v2zpj3sr_mc',
  BILL_LIST_CONFIRM_MODAL_MV: 'b_power_kyi08sr5_mv',
  BILL_LIST_CONFIRM_MODAL_MC: 'b_power_kyi08sr5_mc',
  BILL_LIST_UNBILL_RENT: 'b_power_gtb4ba2p_mc',
  BILL_LIST_UNBILL_SALE: 'b_power_t49ltx2v_mc',
  BILL_LIST_CONFRIM_BUTTON_MV: 'b_power_95viz29a_mv',
  BILL_LIST_CONFRIM_BUTTON_MC: 'b_power_95viz29a_mc',
  BILL_LIST_EXPORT: 'b_power_emjxz0pu_mc',
  BILL_LIST_OLD_BILL_MV: 'b_power_tcrkjw2z_mv',
  BILL_LIST_OLD_BILL_MC: 'b_power_tcrkjw2z_mc',
  BILL_LIST_EXPORT_OLD_BILL_MV: 'b_power_wpm91755_mv',
  BILL_LIST_EXPORT_OLD_BILL_MC: 'b_power_wpm91755_mc',
  BILL_AD_BANNER_MV: 'b_power_o1rdyiow_mv',
  BILL_AD_BANNER_MC: 'b_power_o1rdyiow_mc',

  BILL_MONTH_POI_DATE: 'b_power_eb4p94y2_mc',
  BILL_MONTH_POI_CLEAR_QUESTION: 'b_power_fzr3839t_mc',
  BILL_MONTH_POI_CHECK: 'b_power_32tnzst6_mc',

  NOT_SIGN_CONFIRM: 'b_power_read_conf_mc',
  NOT_SIGN_CLOSE: 'b_power_close_conf_mc',
  HOME_CALL: 'b_power_callserve_hp_mc',
  INTRODUCTION_CALL: 'b_power_call_serve_mc',
  PROFIT_WALLET: 'b_power_wallet_mc',
  DEVICE_CALL: 'b_power_callserve_dev_mc',
  SUPPLEMENTAL_AGREE_BUTTON: 'b_power_katxtyqs_mc',
  SUPPLEMENTAL_DISAGREE_BUTTON: 'b_power_katxbtyqs_mc',
  SUPPLEMENTAL_EXIT_BUTTON: 'b_power_katxtc_mc',
  SUPPLEMENTAL_AGREEMENT_PREVIEW_BUTTON: 'b_power_katxckxy_mc',
  SUBJECT_CHANGE_AGREE_BUTTON: 'b_power_ztbgqs_mc',
  SUBJECT_CHANGE_DISAGREE_BUTTON: 'b_power_9szbwv47_mc',
  SUBJECT_CHANGE_EXIT_BUTTON: 'b_power_ztbgtc_mc',
  SUBJECT_AGREEMENT_PREVIEW_BUTTON: 'b_power_ztbgckxy_mc',
  COOPERATION_RENEW_AGREE_BUTTON: 'b_power_zytxtyqs_mc',
  COOPERATION_RENEW_DISAGREE_BUTTON: 'b_power_zytxbtyqs_mc',
  COOPERATION_RENEW_EXIT_BUTTON: 'b_power_zytxtc_mc',
  COOPERATION_AGREEMENT_PREVIEW_BUTTON: 'b_power_zytxckxy_mc',
  CONTACT_SALESMAN_BUTTON: 'b_power_uif2gidd_mc',
  ANALYTICS_SELECTED_POI: 'b_power_vfaq07wr_mc',
  ANALYTICS_SELECTED_DATE: 'b_power_p8ncjn1r_mc',
  TRADE_EFFECT_MV: 'b_power_kvv9q6gt_mv',
  TRADE_EFFECT_MC: 'b_power_kvv9q6gt_mc',
  TRADE_EFFECT_POI_MC: 'b_power_vo7zjh01_mc',
  SERVICE_LEVEL_POI_LIST_SEARCH: 'b_power_c3s97mba_mc',
  SERVICE_LEVEL_POI_LIST_FILTER_LEVEL: 'b_power_yyl8l38v_mc',
  SERVICE_LEVEL_POI_LIST_FILTER_INDICATOR: 'b_power_coz0tmc1_mc',
  SERVICE_LEVEL_POI_LIST_CALL: 'b_power_0x2zbeoz_mc',
  SERVICE_LEVEL_POI_LIST_GO_POI_DETAIL: 'b_power_wiuw6gu4_mc',
  SERVICE_LEVEL_POI_LIST_SEARCH_SEARCH: 'b_power_w6qgbxoz_mc',
  SERVICE_LEVEL_POI_LIST_SEARCH_FILTER: 'b_power_l505zqlg_mc',
  SERVICE_LEVEL_POI_DETAIL_DAY: 'b_power_20chf8fp_mc',
  SERVICE_LEVEL_POI_DETAIL_MONTH: 'b_power_nl09hu18_mc',
  SERVICE_LEVEL_POI_DETAIL_POWER_OFF: 'b_power_wv7rj5pe_mc',
  SERVICE_LEVEL_POI_DETAIL_POINT_OFF: 'b_power_mz2twci7_mc',
  SERVICE_LEVEL_POI_DETAIL_COMPLAINT: 'b_power_kdjwgbsf_mc',
  SERVICE_LEVEL_POI_DETAIL_CALL: 'b_power_d3yuftkp_mc',
};

export {
  BID,
  CID,
};
